import GLightbox from 'glightbox';

/**
 * Set up sliders.
 */
class IconicModal {
	/**
	 * Class names.
	 *
	 * @type {{}}
	 */
	classes = {
		'lightbox': '.iconic-lightbox',
	};

	/**
	 * Run panels.
	 */
	constructor() {
		const lightbox = GLightbox( {
			selector: this.classes.lightbox,
		} );

		lightbox.on( 'slide_after_load', ( data ) => {
			const image = data.slide.querySelector( 'img' );

			if ( image.complete ) {
				this.loaded( image );
			} else {
				image.addEventListener( 'load', loaded );
			}
		} );
	};

	/**
	 * Fired after image is loaded in lightbox.
	 *
	 * @param image
	 */
	loaded = ( image ) => {
		const naturalWidth = image.naturalWidth;

		// image.closest( '.ginner-container' ).style.maxWidth = naturalWidth / 2 + 'px';
	};
}

export {IconicModal};